import React, { Component } from 'react';
import {
    InstantSearch,
    Hits,
    SearchBox,
    Highlight,
    RefinementList,
    Pagination,
    CurrentRefinements,
    ClearRefinements,
} from 'react-instantsearch/dom';
import { connectHits } from "react-instantsearch/connectors";
import { getPrintValues, getDesigners, checkAdminEmail } from '../../dashBoard/newDashboard/algoliaDashboard/AlgoliaMiscUtils';
import CustomHits from './CustomHits'
import { firebaseAuth, logComponentLoad } from '../../../config/constants.js'

import { getSalesPeople, getDeliveryGuys } from '../../dashBoard/newDashboard/LargeProjects/ApiUtils'
import { getSalesPeopleDropDown, getDeliveryGuysDropdown } from '../../dashBoard/newDashboard/LargeProjects/LargeProjectUtils'

// function Product({ hit }) {

//     //  let tempHit = hit;
//     hit.key = hit.objectID;

//     let user = {
//         email: 'ivanmworozi@gmail.com'
//     }


//     const orderSection = user
//         ?
//         <OrderCard
//             //user={this.state.userFromFirebaseNode}
//             searchNow={true}
//             user={user}
//             order={hit} />
//         : ''


//     return <div style={{ marginTop: '10px' }}>
//         {/* <span className="hit-name">
//             <div>{hit.order_num}</div>
//             <Highlight attribute="name" hit={hit} />
//             <br />
//             <Highlight attribute="phone" hit={hit} />
//         </span>
//         <br />
//         {image} */}
//         {orderSection}

//     </div>
// }

// function CustomTest() {

//     let user1 = {
//         email: 'ivanmworozi@gmail.com'
//     }

//     return (
//         <ConnectedCustomHits
//             // mainCardObjects={this.state.mainCardObjects}
//             // orderStatuses={this.state.orderStatuses}
//             // designers={this.state.designers}
//             user={user1}
//         />
//     )

// }

function Search(user) {

    return (
        <div >
            <Pagination />
            <CurrentRefinements />
            <ClearRefinements />
            <SearchBox showLoadingIndicator />
            <RefinementList attribute="status" />
            <br />
            <RefinementList attribute="itemType" />
            <br />
            <RefinementList attribute="salesPerson" />
            <br />
            <RefinementList attribute="inhouseItem_flag" />
            <br />
            <RefinementList attribute="whatsApp_avail" />

            {/* <RefinementList attribute="gender" />
            <br />
            <RefinementList attribute="ageGroup" /> */}


            {/* <CustomTest /> */}


            {/* USE THE ORIGINAL HIT TO DISPLAY ORDER CARDS */}
            {/* <Hits hitComponent={Product} /> */}

        </div>
    );
}


const ConnectedCustomHits = connectHits(CustomHits);

class SearchNow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orderStatuses: [],
            designers: [],
            user: '',
            algoliaUser: null,
            isAdmin: false,
            refresh: false,
            awaitingRefresh: false,
            salesPeopleChoices: [],
            deliveryPersonChoices: [],
        }
    }

    setRefreshToTrue = () => {
        console.log("upx7710++++++++++ setRefreshToTrue");
        this.setState({
            refresh: true
        })
    }


    setRefreshToFalse = () => {
        console.log("upx77102++++++++++ setRefreshToFalse");
        this.setState({
            refresh: false
        })
    }

    componentDidMount() {
        console.log("addx2 ++++++++++ searchNow componentDidMount");
        getPrintValues("statuses", this.loadStatuses);
        //getPrintValues("adminemail", this.loadAdmins);
        getDesigners(this.loadDesigners);
        getSalesPeople(this.loadSalesPeople);
        getDeliveryGuys(this.loadDelGuys);

        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("addx24 +++++++++:firebaseAuth().onAuthStateChanged");

            if (user) {
                console.log("addx241 user is:" + user.email);
                // let isAnonymous = user.isAnonymous;
                // let uid = user.uid;

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })
                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult);
                }
            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })

            }
        })
    }

    loadDelGuys = (delGuys) => {
        // console.log("getDelguys ++++++++:loadSalesPeopleDropdown");
        // console.log("getdelguys:"+JSON.stringify(delGuys,null,3));
        if (delGuys && delGuys.length > 0) {
            console.log("getdelguys customer dropdown...")
            this.setState({
                deliveryPersonChoices: getDeliveryGuysDropdown(delGuys)
            })
        } else {
            alert("unable to load delivery people")
        }
    }

    loadSalesPeople = (salesPeople) => {
        console.log("getSales2 ++++++++:loadSalesPeopleDropdown");
        // console.log("getSales22:"+JSON.stringify(salesPeople,null,3));
        if (salesPeople && salesPeople.length > 0) {
            console.log("getSales23 customer dropdown...")
            this.setState({
                salesPeopleChoices: getSalesPeopleDropDown(salesPeople)
            })
        } else {
            alert("unable to load salespeople")
        }
    }

    loadStatuses = (statuses) => {
        //  console.log("ddx12 ++++++ loadStatuses ");
        // console.log("ddx121 statuses:" + JSON.stringify(statuses, null, 3));
        this.setState({ orderStatuses: statuses })
    }

    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");
        // console.log("addx2941 returnObject:" + JSON.stringify(returnObject,null,3));

       // logComponentLoad(returnObject, componentName, email) {
        logComponentLoad(returnObject,"searchNow",returnObject.algoliaUser.key);
    

        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })
    }

    // setAdmin = (user) => {
    //     console.log("++++++ addx2 setAdmin");
    //     console.log("addx121 setAdmin:" + user.email);
    //     this.setState({
    //         authed: true,
    //         // loading: false,
    //         user: user,
    //         uid: user.uid,
    //         isAdmin: true
    //     })
    // }

    loadDesigners = (statuses) => {
       // console.log("des12 ++++++ loadDesigners ");
        //console.log("des121 designers:" + JSON.stringify(statuses, null, 3));
        this.setState({ designers: statuses })
    }

    render() {
        const cardListUI = this.state.user && this.state.user.email && this.state.algoliaUser != null && this.state.algoliaUser.isAdmin
            ? <ConnectedCustomHits
                mainCardObjects={this.state.mainCardObjects}
                orderStatuses={this.state.orderStatuses}
                designers={this.state.designers}
                setRefreshToFalse={this.setRefreshToFalse}
                setRefreshToTrue={this.setRefreshToTrue}
                refresh={this.state.refresh}
                awaitingRefresh={this.state.awaitingRefresh}
                user={this.state.user}
                //isAdmin={this.state.isAdmin}
                algoliaUser={this.state.algoliaUser}
                salesPeopleChoices={this.state.salesPeopleChoices}
                deliveryPersonChoices={this.state.deliveryPersonChoices}
                ivan={this.props.match.params.ivan} />
            : <h2>YOU ARE NOT AN AUTHORIZED</h2>


        const App = () => (
            <InstantSearch
                appId="FV5Z3H1RLH"
                apiKey="837deba1029595bbad3d5d1df9dabfeb"
                indexName="printboda_test"
            >
                {/* Search widgets will go there */}
                <Search />
            </InstantSearch>
        );

        const userEmail = this.state.user && this.state.user.email && this.state.algoliaUser
            ? <div>
                <h3>{this.state.user.email}</h3>
                <h4>{"" + this.state.algoliaUser.isAdmin}</h4>
            </div>
            : ''

        const wholeUI = this.state.user && this.state.user.email && this.state.algoliaUser != null && this.state.algoliaUser.isAdmin
            ? <div>

                <Search />

                {userEmail}

                {/* USE OUR OWN CUSTOM COMPONENT TO RENDER LIST */}
                {cardListUI}
            </div>
            : <h2>YOU ARE NOT AUTHORIZED</h2>

        return (
            <div>

                <InstantSearch
                    appId="FV5Z3H1RLH"
                    apiKey="837deba1029595bbad3d5d1df9dabfeb"
                    indexName="printboda_test"
                    refresh={this.state.refresh}
                >
                    {wholeUI}
                </InstantSearch>
            </div>)
    }
}

export default SearchNow;



// WEBPACK FOOTER //
// ./src/components/newSite/algolia/SearchNow.js